import { create } from 'zustand';

/**
 * Client-only UI state for the Communities hub. The search box now lives in the
 * TopNav (rendered above the page outlet), while filtering happens in the page —
 * this store is the shared channel between them.
 */
interface MyCommunitiesUi {
  search: string;
  setSearch: (search: string) => void;
}

export const useMyCommunitiesUi = create<MyCommunitiesUi>((set) => ({
  search: '',
  setSearch: (search) => set({ search }),
}));
